import { useEffect, useState } from "react";
import { COUNTRIES, splitE164, toE164 } from "@/lib/phone";

// Controlled phone input: country dial-code selector + national number, emits full E.164.
// onChange(e164, dial)
export const PhoneField = ({ value, onChange, disabled, testidPrefix = "phone" }) => {
  const init = splitE164(value);
  const [code, setCode] = useState(init.code);
  const [national, setNational] = useState(init.national);

  useEffect(() => {
    const s = splitE164(value);
    if (toE164(s.dial, s.national) !== toE164(dialOf(code), national)) {
      setCode(s.code);
      setNational(s.national);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const dialOf = (c) => COUNTRIES.find((x) => x.code === c)?.dial || "+1";

  const emit = (c, n) => {
    setCode(c);
    setNational(n);
    onChange(toE164(dialOf(c), n), dialOf(c));
  };

  return (
    <div className="flex gap-2">
      <select
        value={code}
        disabled={disabled}
        onChange={(e) => emit(e.target.value, national)}
        data-testid={`${testidPrefix}-country`}
        className="bg-[#0A0A0A] border border-border rounded-sm px-2 text-sm font-mono text-white focus:outline-none focus:ring-1 focus:ring-[#007AFF] max-w-[7.5rem]"
      >
        {COUNTRIES.map((c) => (
          <option key={`${c.code}-${c.dial}`} value={c.code}>
            {c.dial} {c.code}
          </option>
        ))}
      </select>
      <input
        type="tel"
        value={national}
        disabled={disabled}
        onChange={(e) => emit(code, e.target.value.replace(/\D/g, ""))}
        placeholder="555 123 4567"
        data-testid={`${testidPrefix}-national`}
        className="flex-1 bg-[#0A0A0A] border border-border rounded-sm px-3 py-2 text-sm font-mono text-white placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-[#007AFF]"
      />
    </div>
  );
};
